export default (props) => (
  /**
   * Icone "Xy" responsavel por inserir coordenadas.
   * Encontrado no menu de ferramentas.
  */
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.15883 1.6557C9.52097 1.23871 9.4765 0.607107 9.05951 0.244977C8.64252 -0.117154 8.01091 -0.0726831 7.64878 0.344305L9.15883 1.6557ZM0.807293 8.22215C0.445161 8.63914 0.489631 9.27074 0.90662 9.63287C1.32361 9.995 1.95521 9.95053 2.31734 9.53354L0.807293 8.22215ZM7.64878 0.344305L0.807293 8.22215L2.31734 9.53354L9.15883 1.6557L7.64878 0.344305Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M0.806986 1.65667C0.444854 1.23968 0.489325 0.608084 0.906314 0.245953C1.3233 -0.116177 1.95491 -0.0717065 2.31704 0.345281L0.806986 1.65667ZM9.15853 8.22313C9.52066 8.64011 9.47619 9.27171 9.0592 9.63384C8.64221 9.99597 8.01061 9.9515 7.64848 9.53452L9.15853 8.22313ZM2.31704 0.345281L9.15853 8.22313L7.64848 9.53452L0.806986 1.65667L2.31704 0.345281Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M19.8844 4.22598C20.1203 3.72661 19.9067 3.13056 19.4074 2.89465C18.908 2.65874 18.312 2.87231 18.076 3.37168L19.8844 4.22598ZM12.7847 14.5724C12.5488 15.0718 12.7623 15.6678 13.2617 15.9038C13.7611 16.1397 14.3571 15.9261 14.593 15.4267L12.7847 14.5724ZM18.076 3.37168L12.7847 14.5724L14.593 15.4267L19.8844 4.22598L18.076 3.37168Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M12.4171 3.39017C12.1909 2.88635 11.5991 2.66133 11.0952 2.88756C10.5914 3.1138 10.3664 3.70563 10.5926 4.20944L12.4171 3.39017ZM14.1778 12.1931C14.404 12.6969 14.9959 12.922 15.4997 12.6957C16.0035 12.4695 16.2285 11.8777 16.0023 11.3738L14.1778 12.1931ZM10.5926 4.20944L14.1778 12.1931L16.0023 11.3738L12.4171 3.39017L10.5926 4.20944Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);
